export class CustomerImage {
  imageStream: any;
  fileExtension = "";
  error = "";
  name = "";
}